// extracted by mini-css-extract-plugin
export default {"clearfix":"ConfirmEmailChange_clearfix__gz7SD","confirmEmailChange":"ConfirmEmailChange_confirmEmailChange__M9x-+","inner":"ConfirmEmailChange_inner__FxrIS"};